const funcion11 = {
    titulo: `Función: funciones anidadas`,
    problemas: [
      {
        codigo: 1,
        descripcion: `En JavaScript se puede declarar una función dentro de otra función, luego se dice que la función interna es una función anidada.
La función anidada solo se puede llamar dentro de la función padre. Por ejemplo:`,
        programa: `function hipotenusa(ladoa, ladob) {
  function cuadrado(x) {
    return x * x
  }
  
  const hipo = Math.sqrt(cuadrado(ladoa) + cuadrado(ladob))
  return hipo
}
      
console.log(hipotenusa(3, 4))`,
        solucion: "5"
      }, {
        codigo: 2,
        descripcion: `La función interna cuadrado(x) no se puede llamar desde fuera de la función hipotenusa. Se genera un error.`,
        programa: `function hipotenusa(ladoa, ladob) {
  function cuadrado(x) {
    return x * x
  }
  const hipo = Math.sqrt(cuadrado(ladoa) + cuadrado(ladob))
  return hipo
}

console.log(cuadrado(10))`,
        solucion: ""
      }, {
        codigo: 3,
        descripcion: `Las funciones anidadas o internas pueden acceder a los parámetros y variables de la función padre.`,
        programa: `function funcionExterna(a) {
  const b=2
  function funcionInterna(c) {
    const d=4
    const suma=a+b+c+d
    console.log(suma)
  }
  funcionInterna(3)
}
          
funcionExterna(1)`,
        solucion: "10"
      }, {
        codigo: 4,
        descripcion: `La función externa no puede acceder a las variables de la función interna, se genera un error.`,
        programa: `function funcionExterna(a) {
  const b=2
  function funcionInterna() {
    const c=4
  }
  funcionInterna()
  let suma=a+b+c
  console.log(suma)
}
                    
funcionExterna(1)`,
        solucion: ""
      }, {
        codigo: 5,
        descripcion: `Una función puede tener más de una función anidada.`,
        programa: `function menorMayor(arreglo) {
  function menor() {
    let menor = arreglo[0]
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i] < menor) {
        menor = arreglo[i]
      }
    }
    return menor
  }            
  function mayor() {
    let mayor = arreglo[0]
    for (let i = 0; i < arreglo.length; i++) {
      if (arreglo[i] > mayor) {
        mayor = arreglo[i]
      }
    }
    return mayor
  }  
  return [menor(), mayor()]
}
      
console.log(menorMayor([10,5,70,55,40]))`,
        solucion: "[5, 70]"
      }, {
        codigo: 6,
        descripcion: `Las funciones anidadas también pueden tener ellas otras funciones anidadas. Se cumplen las mismas reglas que hemos visto en ejercicios anteriores`,
        programa: `function funciona(a) {
  function funcionb(b) {
    function funcionc(c) {
      const suma = a + b + c
      console.log(suma)
    }
    funcionc(1)
  }
  funcionb(1)
}
      
funciona(1)`,
        solucion: "3"
      }, {
        codigo: 7,
        descripcion: `Hay que tener cuidado cuando definimos los nombres de variables y parámetros en las funciones anidadas, si los mismos tienen el mismo nombre que las variables o parámetros de la funcion padre, luego no se puede tener acceso a las variables del padre.`,
        programa: `function padre(x) {
  const y=10
  function hija(x) {
    const y=1
    console.log(x+y)
  }
  hija(1)
}
      
padre(10)`,
        solucion: "2"
      }, {
        codigo: 8,
        descripcion: `Las funciones internas se las llama también funciones closure (cierre) debido a que tienen acceso a las variables y parámetros de la función padre. Luego podemos retornar la función interna y dejar encapsulado las variables y parámetros del padre.
Veamos un ejemplo donde la función almacena la cantidad de vidas del jugador en una variable de la función padre y la decrementa y retorna en cada llamada:`,
        programa: `function vidasJugador() {
  let vidas = 3
          
  function decrementar() {
    if (vidas===0)
      return 0
    vidas--
    return vidas
  }
          
  return decrementar // retornamos la referencia de la función interna
}
          
const restarVida=vidasJugador() // Almacenamos la función interna
restarVida() // decrementamos la vida y la retorna
console.log(restarVida()) // decrementamos la vida y la retorna`,
        solucion: "1"
      }, {
        codigo: 9,
        descripcion: `Podemos inclusive retornar un objeto con la referencia de las funciones internas.`,
        programa: `function vidasJugador() {
  let vidas = 3
        
  function decrementar() {
    if (vidas===0)
      return 0
    vidas--
    return vidas
  }
    
  function incrementar() {
    vidas++
    return vidas
  }
    
  function retornar() {
    return vidas
  }
        
  return {
            decrementar,
            incrementar,
            retornar
         }
}
        
const vidas=vidasJugador()
vidas.decrementar()
vidas.decrementar()
vidas.incrementar()
console.log(vidas.retornar())    `,
        solucion: "2"
      }
    ]
  }
  
  export default funcion11;